import { connect } from "react-redux";

import RightSidebarContent from "~/components/RightSidebar/RightSidebarContent/RightSidebarContent";

import {
  selectRightSidebarIsOpen,
  selectRightSidebarActiveTab,
  switchTabOnSidebarRight,
  closeSidebarRight
} from "~/store/ducks/user/uistate";
import { selectIsEditMode } from "~/store/ducks/application/materials/isEditMode";
import {
  selectShowMaterialsOnPageTab,
  selectShowAllMaterialsTab
} from "~/store/ducks/domain/ui/sidebarRight";
import { showModal } from "~/store/ducks/domain/ui/modal";
import {
  selectIsPresentationActive,
  selectIsDlsActive,
  selectDlsActiveTab,
  setDlsActiveTab,
  setDlsActiveCategory
} from "~/store/ducks/user/uistate";
import {
  selectCategories,
  selectCurrentDlsCategory
} from "~/store/selectors/dls";

import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";

function mapStateToProps(state) {
  const activeTab = selectRightSidebarActiveTab(state);

  return {
    activeTab,
    dlsActiveTab: selectDlsActiveTab(state),
    isDlsActive: selectIsDlsActive(state),
    isPresentationActive: selectIsPresentationActive(state),
    isEditMode: selectIsEditMode(state),
    isSidebarRightOpen: selectRightSidebarIsOpen(state),
    showMaterialsOnPageTab: selectShowMaterialsOnPageTab(state),
    showAllMaterialsTab: selectShowAllMaterialsTab(state),
    dlsCategories: selectCategories(state),
    dlsActiveCategory: selectCurrentDlsCategory(state),
    isGreaterThanMedium: selectIsGreaterThanMedium(state)
  };
}

const mapDispatchToProps = {
  switchTabOnSidebarRight,
  showModal,
  setDlsActiveTab,
  setDlsActiveCategory,
  closeSidebarRight
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSidebarContent);
